module.exports = "<div seedelement aria-label=\"breadcrumbs\"><slot></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-breadcrumb/theme/lui-breadcrumb.html
// module id = 171
// module chunks = 0 1 11